import { sendGTMEvent } from "@next/third-parties/google";
import {
	Actioner,
	BuyFlowActionKeys,
	GTMActionKeys,
	type IKeyDefValue,
	type IListenerHandle,
} from "@services/actioner";
import Cookies from "js-cookie";

export const GA_TRACKING_ID = process.env.GA_TRACKING_KEY;

export const gaEvent = ({ action, category, label, value }) => {
	window.gtag("event", action, {
		event_category: category,
		event_label: label,
		value: value,
	});
};

const keys: IKeyDefValue[] = [
	...Object.values(GTMActionKeys),
	BuyFlowActionKeys.BUY_SET_BRAZE_ID,
	BuyFlowActionKeys.BUY_SELECT_PRODUCT,
	BuyFlowActionKeys.BUY_DESELECT_PRODUCT,
];

let listeners: IListenerHandle[] = [];

const GTM = {
	start: () => {
		// TODO: make these log dev only
		// console.log("Google Tag Manager started");
		listeners = Actioner.addListenerToKeys(keys)((payload) => {
			// TODO: make these log dev only
			// console.log("Google Tag Manager event", payload);

			const { actionKey, ...params } = payload;

			switch (actionKey) {
				case BuyFlowActionKeys.BUY_SELECT_PRODUCT:
					sendGTMEvent({
						event: "addToCart",
						ecommerce: {
							currencyCode: "AUD",
							add: {
								products: [
									{
										id: params.id,
										name: params.name,
										price: params.price,
										category: params.type,
										quantity: 1,
									},
								],
							},
						},
					});
					break;
				case BuyFlowActionKeys.BUY_DESELECT_PRODUCT:
					sendGTMEvent({
						event: "removeFromCart",
						ecommerce: {
							currencyCode: "AUD",
							remove: {
								products: [
									{
										id: params.id,
										name: params.name,
										price: params.price,
										category: params.type,
										quantity: 1,
									},
								],
							},
						},
					});
					break;
				case BuyFlowActionKeys.BUY_SET_BRAZE_ID:
					sendGTMEvent({
						userId: params.externalId,
					});
					Cookies.set("userID", params.externalId);
					break;
				case GTMActionKeys.FORM_START:
					sendGTMEvent({
						event: "formStart",
						...params,
					});
					break;
				case GTMActionKeys.BUY_SET_SIM_CHANNEL:
					sendGTMEvent({
						event: "BUY_SET_SIM_CHANNEL",
						simChannel: params.simChannel,
					});
					break;
				case GTMActionKeys.FORM_ERROR:
					sendGTMEvent({
						event: "formError",
						...params,
					});
					break;
				case GTMActionKeys.FORM_STEP_COMPLETE:
					sendGTMEvent({
						event: "formStepComplete",
						...params,
					});
					break;
				case GTMActionKeys.FORM_SUBMIT_SUCCESS:
					sendGTMEvent({
						event: "formSubmitSuccess",
						...params,
					});
					break;
				case GTMActionKeys.CHECKOUT:
					sendGTMEvent({
						event: "checkout",
						...params,
					});
					break;
				case GTMActionKeys.PURCHASE:
					sendGTMEvent({
						event: "purchase",
						...params,
					});
					break;
				case GTMActionKeys.LIVE_CHAT_OPEN:
					sendGTMEvent({
						event: "liveChatOpen",
						...params,
					});
					break;
				case GTMActionKeys.CTA_CLICK:
					sendGTMEvent({
						...params,
					});
					break;
				case GTMActionKeys.REQUEST_TIMEOUT:
					sendGTMEvent({
						event: "REQUEST_TIMEOUT",
					});
					break;
				default:
					break;
			}
		});
	},
	stop: () => {
		listeners.forEach((listener) => listener.remove());
	},
};

export default GTM;
